// src/contexts/tokenContextDef.ts
import { createContext } from "react";

export interface TokenContextValue {
  // Identifiers
  tokenId: string;
  ticker: string;
  symbolForBinance: string;
  name: string;
  logoUrl: string | null;
  sectorName: string | null;

  // Price data
  displayPrice: number | null;
  price24hChange: number | null;
  snapshotPrice: number | null;
  ws24hChangeDecimal: number | null;

  // Metrics
  marketCap: number | null;
  volume: number | null;
  tvl: number | null;
  fees: number | null;
  revenue: number | null;

  // Ratios
  ratioMcTvl: number | null;
  ratioMcFees: number | null;
  ratioMcDau: number | null;
  ratioMcTx: number | null;
  ratioTvlToFees: number | null;
  ratioTvlToVol: number | null;

  // Changes by window
  changesByWindow: Record<string, number | null>;

  // Loading states
  isLoading: boolean;
  isLoadingScreenerData: boolean;

  // Last updated
  lastUpdated: string | null;

  // Data source info
  useBackendPrice: boolean;

  // Binance data (for 24h high/low, etc.)
  priceData: {
    price?: string;
    priceChange?: string;
    high24h?: string;
    low24h?: string;
    volume24h?: string;
  } | null;
}

export const TokenContext = createContext<TokenContextValue | null>(null);

